import { instance } from "./api";

export async function getCategoryData(payloads) {
  const { results, page, filters } = payloads;

  const applyFilter = filters?.length > 0 ? "&filter=" + filters : "";
  return instance
    .get(`/admin/getCategoryData?limit=${results}&page=${page}${applyFilter}`)
    .then((res) => res.data);
}

export async function getDefaultCategory(payload) {
  const { filter } = payload;
  let applyFilter = filter === "" ? "" : `?filter=${filter}`;

  return instance.get(`/user/category${applyFilter}`).then((res) => res.data);
}

export async function createSubCategory(payload) {
  const formData = new FormData();
  formData.append("Cat_ID", payload.Cat_ID);
  formData.append("Cat_Desc", payload.Sub_Cat_Desc);
  formData.append("Cat_Value", payload.Cat_Value);

  const response = await instance.post("admin/addSubCategory", formData);
  return response.data;
}
export async function updateSubCategory(payload) {
  const formData = new FormData();
  formData.append("Cat_Value", payload.Cat_Value);
  formData.append("Cat_Desc", payload.Sub_Cat_Desc);
  formData.append("Is_Active", payload.Is_Active.toString());

  const response = await instance.post(
    `admin/updateSubCategory/${payload.params}`,
    formData
  );
  return response.data;
}
